module.exports = __webpack_public_path__ + "static/media/915ty@3x.962f5d1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/915ty@3x.png
// module id = 1702
// module chunks = 0 1